const th = {
    nav: {
      home: "หน้าแรก",
      browse: "ค้นหางานแต่งงาน",
      dashboard: "แดชบอร์ด",
      messages: "ข้อความ",
      profile: "โปรไฟล์",
      login: "เข้าสู่ระบบ",
      register: "ลงทะเบียน",
      logout: "ออกจากระบบ",
      admin: "ผู้ดูแล",
      faq: "คำถามที่พบบ่อย",
      about: "เกี่ยวกับเรา",
      contact: "ติดต่อเรา",
      pricing: "ราคา",
      howItWorks: "วิธีการทำงาน",
    },
    auth: {
      login: {
        title: "ยินดีต้อนรับกลับ",
        email: "อีเมล",
        password: "รหัสผ่าน",
        button: "เข้าสู่ระบบ",
        noAccount: "ยังไม่มีบัญชี?",
        register: "ลงทะเบียนเลย",
      },
      register: {
        title: "สร้างบัญชี",
        name: "ชื่อเต็ม",
        email: "อีเมล",
        password: "รหัสผ่าน",
        role: "ฉันต้องการ...",
        roleHost: "จัดงานแต่งงาน",
        roleGuest: "เข้าร่วมงานแต่งงาน",
        terms: "ฉันยอมรับข้อกำหนดและนโยบายความเป็นส่วนตัว",
        button: "ลงทะเบียน",
        hasAccount: "มีบัญชีแล้ว?",
        login: "เข้าสู่ระบบเลย",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "กำลังโหลด...",
      error: "เกิดข้อผิดพลาด",
      success: "สำเร็จ",
      save: "บันทึก",
      cancel: "ยกเลิก",
      delete: "ลบ",
      edit: "แก้ไข",
      back: "กลับ",
      next: "ถัดไป",
      language: "ภาษา",
      currency: "สกุลเงิน",
      search: "ค้นหา",
      filter: "กรอง",
      all: "ทั้งหมด",
      none: "ไม่มี",
      yes: "ใช่",
      no: "ไม่",
    },
    footer: {
      about: "เกี่ยวกับ",
      privacy: "ความเป็นส่วนตัว",
      terms: "ข้อกำหนด",
      contact: "ติดต่อ",
      copyright: "© 2024 WEDVAYA. สงวนลิขสิทธิ์",
    },
  };

export default th;
